import { memo } from 'react';

import { LevelProps } from './types';

const LevelComponent = ({
  component: Component,
  childComponent,
  children,
}: LevelProps) => (
  <Component>
    {childComponent && (
      <LevelComponent
        childComponent={childComponent.childComponent}
        component={childComponent.component}
      >
        {children}
      </LevelComponent>
    )}
    {!childComponent && children}
  </Component>
);

export const Level = memo(LevelComponent);
